// Only the two deploys that carry real user sessions. Deliberately excludes
// dev and the ephemeral branch previews under *.dev.trackable.io, so internal
// and throwaway traffic never opens conversations in the live workspace.
const INTERCOM_ORIGIN = /^https:\/\/(app|next\.app)\.trackable\.io$/

/**
 * Dev-only preview: `localStorage.trkIntercomLocal = 'true'` loads the widget
 * on an origin the gate excludes (localhost, a branch preview) so the launcher
 * can be checked before deploying. Off by default so those sessions stay out
 * of the live workspace.
 */
export const LOCAL_OVERRIDE_STORAGE_KEY = `trkIntercomLocal`

export function localOverrideEnabled() {
  try {
    return typeof localStorage !== `undefined` && localStorage.getItem(LOCAL_OVERRIDE_STORAGE_KEY) === `true`
    // oxlint-disable-next-line local/require-catch-logging -- storage can be blocked, the flag is dev-only
  } catch {
    return false
  }
}

export function shouldLoadIntercom(origin, pathname, localOverride = false) {
  if (!INTERCOM_ORIGIN.test(origin) && !localOverride) return false
  // removes intercom from the public scheduling page
  if (pathname.match(/^\/scheduling\/?/)) return false
  return true
}

// Whether the widget is expected on this page. AppLayout uses this to decide
// whether to wait for `window.Intercom`, so the loader and the boot can never
// disagree about which origins are covered.
export function intercomEnabled() {
  return shouldLoadIntercom(document.location.origin, location.pathname, localOverrideEnabled())
}

export function intercom() {
  if (!intercomEnabled()) return

  //Set your APP_ID
  var APP_ID = `m8f1sces`

  window.intercomSettings = {
    app_id: APP_ID,
    // The floating launcher sat over the contact drawer's Send button (and the
    // inbox composer). The sidebar's Help button opens the messenger instead.
    hide_default_launcher: true,
  }
  ;(function () {
    var w = window
    var ic = w.Intercom
    if (typeof ic === `function`) {
      ic(`reattach_activator`)
      ic(`update`, w.intercomSettings)
    } else {
      var d = document
      var i = function () {
        i.c(arguments)
      }
      i.q = []
      i.c = function (args) {
        i.q.push(args)
      }
      w.Intercom = i
      var l = function () {
        var s = d.createElement(`script`)
        s.type = `text/javascript`
        s.async = true
        s.src = `https://widget.intercom.io/widget/` + APP_ID
        var x = d.getElementsByTagName(`script`)[0]
        x.parentNode.insertBefore(s, x)
      }
      if (document.readyState === `complete`) {
        l()
      } else if (w.attachEvent) {
        w.attachEvent(`onload`, l)
      } else {
        w.addEventListener(`load`, l, false)
      }
    }
  })()
}
